import React from 'react';
import SettingsCalendar from '../settings/SettingsCalendar';

const Calendar: React.FC = () => {
  return <SettingsCalendar hideSettingsHeader={true} />;
};

export default Calendar;
